/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=82e371f0&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=82e371f0&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=82e371f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d85da01a77df37a43522584b1e40a7a6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e371f0"]])

export default __exports__